import { render, staticRenderFns } from "./YesNoSelectors.vue?vue&type=template&id=0546478a&scoped=true"
import script from "./YesNoSelectors.vue?vue&type=script&lang=js"
export * from "./YesNoSelectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0546478a",
  null
  
)

export default component.exports